<template>
    <div>
        <b-modal v-model="showModal" :title="secretStore.isValid?$t('login.kirjautuneena', currentLocale):$t('login.kirjaudu', currentLocale)" ok-only :ok-title="secretStore.isValid?$t('login.jatka', currentLocale):$t('login.jatkakirjautumatta', currentLocale)" >
            <div class="col-md-12 text-center form-group">
                <div class="p-3" v-if="!secretStore.isInitialized">
                </div>

                <div class="p-3" v-else-if="secretStore.isValid">
                    <h1>{{ $t('login.email', currentLocale) }}</h1>
                    <h2>{{ secretStore.getEmail() }}</h2>
                    <h1 class="mt-4">{{ $t('login.koodi', currentLocale) }}</h1>
                    <h2>{{ secretStore.getCode() }}</h2>
                    <!-- <p>Laita koodi talteen. Voit jatkaa koodin avulla siitä mihin jäit toisella laitteella.</p> -->
                    <button class="button padded" @click="logout()" style="background-color: #059DF3">
                        {{ $t('login.kirjauduulos', currentLocale) }}
                    </button>
                </div>

                <div class="p-3" v-else>
                    <p>{{ $t('login.ohje', currentLocale) }}</p>
                    <h1>{{ $t('login.email', currentLocale) }}</h1>
                    <input class="form-control" type="email" placeholder="" ref="email" :value="email" @keyup="updateFields()">
                    <h1 class="mt-4" v-show="secretStore.needCode">{{ $t('login.koodi', currentLocale) }}</h1>
                    <input class="form-control" v-show="secretStore.needCode" type="text" placeholder="" ref="code" @keyup="updateFields()">
                    <p class="p-3" v-show="secretStore.needCode">
                        {{ $t('login.eikoodia', currentLocale) }}
                    </p>
                    <button class="button padded" @click="processForm()" style="background-color: #059DF3">
                        <span v-if="code === '' && secretStore.needCode">{{(secretStore.sendingCode === 0)?$t('login.laheta', currentLocale):(secretStore.sendingCode === 1)?$t('login.lahetetaan', currentLocale):$t('login.lahetetty', currentLocale)}}</span>
                        <span v-else>{{loginSpinner?$t('login.kirjaudutaan', currentLocale):$t('login.kirjaudu', currentLocale)}}</span>
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
  import secretStore from '../../utils/localstorage'

  export default {
    data: function () {
      return {
        showModal: false,
        email: secretStore.getEmail(),
        code: "",
        secretStore,
        loginSpinner: false
      }
    },
    props: {
      isVisible: true
    },
    methods: {
      show: function() {
        this.showModal = true
      },
      updateFields: function () {
        this.email = this.$refs["email"].value
        if (this.$refs["code"]) {
          this.code = this.$refs["code"].value
        }
      },
      processForm: function () {
        this.email = this.$refs["email"].value
        if (this.$refs["code"]) {
          this.code = this.$refs["code"].value
        }
        if (!secretStore.isValid && this.email) {
          secretStore.setEmail(this.email)
          if (!secretStore.needCode || this.code) {
            // code is entered
            this.loginSpinner = true
            let spinner = this.loginSpinner
            secretStore.login({ email: this.email, code: this.code, success: function () {
              // Login successful
                spinner = false
                secretStore.syncData();
              }, failure: function (error) {
                if (error === 2) {
                  // Needs code
                  spinner = false
                }
              } })
          } else {
            // Ask for code
            secretStore.requestCode()
          }
        }
      },
      logout: function () {
        this.email = ''
        secretStore.logout()
        this.loginSpinner = false
      }
    },
    computed: {
        currentLocale() {
            return this.$route.params.locale
        },
    },
  }

</script>


// WEBPACK FOOTER //
// src/views/components/Modal.vue